
<div class="container">
    <div class="row justify-content-center">
        <div class="box d-none d-lg-block col-sm-12 col-lg-7">
            <div class="box__cont box__cont--image">  
            </div>
        </div>
        <div class="box col-12 col-md-8 col-lg-5">
            <div class="box__cont">
                <div class="box__title">
                    <h1>Sign In</h1>
                    <h2>to access Partners Portal</h2>
                    <!-- <h3 class="box__error-notif" *ngIf="isNotValidInputs">company code/ password is invalid</h3> -->
                    <h3 class="box__error-notif" *ngIf="isNotValidInputs">All fields are required. Please try again.</h3>
                    <h3 class="box__error-notif" *ngIf="wrongCreds"> Log in credentials is not valid. Please try again.</h3>
                    <h3 class="box__error-notif" *ngIf="attemptText">{{ attemptText }}</h3>
                </div>
                <div class="box__form">
                    <div class="col-12 box__field">
                        <atram-textbox [parentFormGroup]="searchFormGroup"
                                        type="text"
                                        controlName="email" 
                                        label="E-mail"
                                        [showPhNumber]="false"
                                        placeholder="E-mail"
                                        [isError]="isErrorEmail || (!searchFormGroup.get('email')?.valid && searchFormGroup.get('email')?.touched)"
                                        [isRequired]="true">
                        </atram-textbox>
                        <!-- <h3 class="box__error-notif" *ngIf="!searchFormGroup.get('email')?.valid && searchFormGroup.get('email')?.touched && searchFormGroup.get('email')?.value">Incorrect E-mail format. try again.</h3> -->
                    </div>
                    <div class="col-12 box__field">
                        <atram-textbox [parentFormGroup]="searchFormGroup"
                                        type="text"
                                        controlName="companyCode"
                                        label="Company Code"
                                        placeholder="Company Code"
                                        [isError]="isErrorCompanyCode || (!searchFormGroup.get('companyCode')?.valid && searchFormGroup.get('companyCode')?.touched)"
                                        [isRequired]="true">
                        </atram-textbox>
                    </div>
                    <div class="col-12 box__field">
                        <atram-textbox [parentFormGroup]="searchFormGroup"
                                        type="password"
                                        controlName="pass"
                                        label="Password"
                                        placeholder="Password"
                                        [showEyeButton]="true"
                                        [isError]="isErrorPassword || (!searchFormGroup.get('pass')?.valid && searchFormGroup.get('pass')?.touched)"
                                        [isRequired]="true">
                        </atram-textbox>
                    </div>                        
                    <div class="col-12 col-sm-6 box__hyperlink">
                        <span (click)="goToForgotPassword()">Forgot Password?</span>
                    </div>  
                    <div class="row">
                        <div class="col-12 text-right">
                            <div class="buttons">
                                <atram-button label="Next"
                                                componentClass="btn-submit"
                                                (on-click)="proceed()">
                                </atram-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
